import { useState, useEffect } from 'react';
import { getStoreId } from '../utils/storeUtils';

// The temporary URL to fetch products from
const PRODUCTS_URL = `https://dnzp6dhrl0ccw.cloudfront.net/stores/${getStoreId()}/index.json`;

// This function fetches the products data from the temporary URL
const fetchProductsData = async () => {
  try {
    const response = await fetch(PRODUCTS_URL);
    if (!response.ok) {
      throw new Error(`Failed to fetch products: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching products:', error);
    return []; // Return empty array as fallback
  }
};

// Initialize with empty array, will be populated when data is fetched
let productsData = [];

// Flag to track if we've started fetching
let isFetching = false;

// Promise that will be resolved when data is loaded
let dataLoadedPromise = null;

// Function to initialize data loading
const initializeProductsData = () => {
  if (!isFetching) {
    isFetching = true;
    dataLoadedPromise = fetchProductsData().then(data => {
      productsData = data;
      return data;
    });
  }
  return dataLoadedPromise;
};

// Initialize data loading right away
initializeProductsData();

// Hook for components that need to use the data
export const useProductsData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    
    // If we already have the data, use it immediately
    if (productsData.length > 0) {
      setData(productsData);
      setLoading(false);
    } else {
      // Otherwise wait for the fetch to complete
      initializeProductsData()
        .then(data => {
          if (isMounted) {
            setData(data);
            setLoading(false);
          }
        })
        .catch(err => {
          if (isMounted) {
            setError(err);
            setLoading(false);
          }
        });
    }
    
    return () => {
      isMounted = false;
    };
  }, []);

  return { data, loading, error };
};

// For non-React code that needs synchronous access
export const getProductsData = () => {
  return productsData;
};

// Export for legacy compatibility and immediate access
export default productsData; 